import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import PageLoading from "../../components/shared/loading/pageLoading/PageLoading";
import { checkAuthentication } from '../../store/auth/authSlice';

const PublicRoutes = () => {
  const dispatch = useDispatch();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    dispatch(checkAuthentication())
      .unwrap()
      .then(_ => {
        setLoaded(true);
      }).catch(_ => {
        setLoaded(true);
      });
  }, [dispatch]);

  return loaded ? (
    <Outlet />
  ) : <PageLoading />;
};

export default PublicRoutes;
